/**
 * What the chain has to answer for, beside the chart.
 *
 * A list of complaints with no way to find what they are complaining
 * about is a list nobody works through, so every line brings the boxes
 * it is about into view and selects them. That is the whole interaction:
 * read a line, look at the chart, decide.
 *
 * Beside the canvas rather than over it, because the answer to a finding
 * is almost always visible on the chart and a panel covering the chart
 * covers the answer.
 */
import { checkSummary } from '../../lib/canvas/chainCheck.js';
import './ChainCheck.css';

const LEVELS = {
  problem: { label: 'Problem', order: 0 },
  check: { label: 'Check', order: 1 },
  note: { label: 'Note', order: 2 },
};

export default function ChainCheck({ findings, chosen, onChoose, onClose }) {
  const problems = findings.filter((f) => f.level === 'problem').length;

  return (
    <aside className="cc" aria-label="Chain check">
      <header className="cc-head">
        <div>
          <strong>Chain check</strong>
          <p className={`cc-summary${problems ? ' is-bad' : ''}`}>{checkSummary(findings)}</p>
        </div>
        <button type="button" className="btn-sm" onClick={onClose} aria-label="Close the chain check">
          ✕
        </button>
      </header>

      {findings.length === 0 && (
        <p className="cc-empty">
          Nothing on the canvas to read yet. Draw the chain, or build it from the
          runsheet, and check it again.
        </p>
      )}

      <ol className="cc-list">
        {findings.map((finding, i) => (
          <li key={`${finding.kind}-${i}`}>
            <button
              type="button"
              className={`cc-item is-${finding.level}${chosen === i ? ' is-open' : ''}`}
              onClick={() => onChoose(i, finding)}
            >
              <span className={`cc-tag is-${finding.level}`}>{LEVELS[finding.level].label}</span>
              <span className="cc-said">{finding.message}</span>
            </button>
          </li>
        ))}
      </ol>

      <p className="cc-foot">
        Read off the chart itself, so it only says what the boxes say. A deed with
        no legible date or share is left out of the reading rather than guessed at.
      </p>
    </aside>
  );
}
